import { action, autorun, computed, makeObservable, observable, reaction } from 'mobx';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { freeBetStore } from '@pascal/pascal-core';
import { soundService, soundTypes } from '../services/SoundService';
import { mathConfig, mathJS } from '../helpers/mathFormat';

class DoBetStore {
  selectedAmount = 10;

  totalBet = 0;

  reBet = null;

  reBetAmount = 0;

  quickBets = [];

  gambleType = null;

  isShowGamble = false;

  constructor() {
    makeObservable(this, {
      quickBets: observable,
      selectedAmount: observable,
      isShowGamble: observable,
      gambleType: observable,
      setDouble: action.bound,
      setHalve: action.bound,
      setQuickBets: action.bound,
      setIsShowGamble: action.bound,
      setSelectedAmount: action.bound,
      setGambleType: action.bound,
      limitsByBetType: computed,
    });
    autorun(() => {
      if (freeBetStore.activeFreeBet.id) {
        this.setSelectedAmount(freeBetStore.activeFreeBet.amount);
      }
    });

    reaction(
      () => freeBetStore.activeFreeBet.id,
      (value, previousValue) => {
        if (previousValue && !value) {
          const { limits } = gameConfigStore;
          const { balance } = userInfoStore;
          this.setSelectedAmount(
            limits?.quickBets[1] > balance ? limits?.quickBets[0] : limits?.quickBets[1]
          );
        }
      }
    );
  }

  setSelectedAmount(value) {
    this.selectedAmount = value;
  }

  setDouble() {
    soundService.play(soundTypes.chip);
    if (this.selectedAmount * 2 > this.limitsByBetType.maxBet) {
      this.selectedAmount = this.limitsByBetType.maxBet;
    }
    if (this.selectedAmount * 2 <= this.limitsByBetType.maxBet) {
      this.selectedAmount = +mathJS.format(this.selectedAmount * 2, mathConfig);
    }
  }

  setIsShowGamble(bool) {
    this.isShowGamble = bool;
  }

  setGambleType(type) {
    this.gambleType = type;
  }

  setHalve() {
    soundService.play(soundTypes.chip);
    if (this.selectedAmount / 2 < this.limitsByBetType.minBet) {
      this.selectedAmount = this.limitsByBetType.minBet;
    }
    if (this.selectedAmount / 2 >= this.limitsByBetType.minBet) {
      this.selectedAmount = +mathJS.format(this.selectedAmount / 2, mathConfig);
    }
  }

  get limitsByBetType() {
    const { limits } = gameConfigStore;
    return limits;
  }

  setQuickBets(quickBets) {
    this.quickBets = [...quickBets].reverse();
  }
}

export const doBetStore = new DoBetStore();
